import Router from 'lib/Router';

import LocateView from 'view/pond/locate';
import SearchView from 'view/pond/search';
import PondView from 'view/pond/view';
import MineView from 'view/pond/mine';

import Pond from 'model/Pond';
import PondList from 'model/PondList';
import config from 'config';
import * as repo from 'db/repositories';
import { loadPondPage } from 'db/persist';

export default Router.extend({
	routes: {
		'pond/locate': 'executeLocate',
		'pond/search': 'executeSearch',
		'pond/view/:id': 'executeView',
		'pond/mine(/:page)': 'executeMine',
	},

	unsecure: [ 'executeLocate', 'executeView', 'executeSearch' ],


	// création d'une mare (en tmp)
	executeLocate: function()
	{
		var pond = new Pond;
		if( app.is('authenticated') )
		{
			var user = app.getStore('user');
			if( user )
			{
				pond.set({
					user_id:    user.get('id'),
					user_uuid:  user.get('uuid'),
					user_name:  user.get('name'),
					user_email: user.get('email'),
					user_zip:   user.get('zip'),
				});
			}
		}

		var view = new LocateView({
			model: pond
		});

		app.render( view );
		app.history.push( Backbone.history.getHash() );
	},



	executeSearch: function()
	{
		var view = new SearchView({

		});

		app.render( view );
		app.history.push( Backbone.history.getHash() );
	},



	executeView: function( id )
	{
		loadPondPage( id ).then( function( pond )
		{
			if( !pond )
			{
				return console.error404();
			}

			var view = new PondView({
				model: pond
			});

			app.render( view );
			app.history.push( Backbone.history.getHash() );
		} ).catch( function( err )
		{
			console.error( 'pond/view', err );
			console.error404();
		} );
	},

	// Liste paginée des mares de l'utilisateur connecté
	executeMine: function( page )
	{
		var userUuid = app.getStore( 'user' ).get( 'uuid' );
		var pageSize = config.page_size;
		var requested = parseInt( page, 10 );

		// Page invalide ou < 1 → page 1
		if( !requested || requested < 1 )
		{
			requested = 1;
		}

		repo.getPondsByUser( userUuid, {
			offset: ( requested - 1 ) * pageSize,
			limit: pageSize,
		} ).then( function( result )
		{
			var maxPage = Math.max( 1, Math.ceil( result.total / pageSize ) );

			// Page trop grande → rediriger vers la dernière page
			if( requested > maxPage )
			{
				return app.redirect( 'pond/mine/' + maxPage );
			}

			var collection = new PondList();
			collection.reset( result.items, { silent: true, parse: true } );

			var view = new MineView({
				collection: collection,
			});
			view.page = requested;
			view.total = result.total;

			app.render( view );
			app.history.push( Backbone.history.getHash() );
		} );
	},
});
